import React from "react";

// import Herkula from "../../images/Partner/partner-1.jpg";
import Livesmart from "../../images/Partner/partner-2.jpg";
import Momentive from "../../images/Partner/partner-3.jpg";
import Fenzi from "../../images/Partner/partner-4.jpg";
import Obermeyer from "../../images/Partner/new-one.jpg";

function OurPartners() {
  const partners = [
    // { src: Herkula, alt: "Herkula" },
    { src: Momentive, alt: "Momentive" },
    { src: Fenzi, alt: "Fenzi" },
    { src: Obermeyer, alt: "Obermeyer" },
    { src: Livesmart, alt: "Livesmart" },
  ];

  const firstRow = partners.slice(0, 3);
  const secondRow = partners.slice(3);

  return (
    <div className="bg-[#0C2341] py-2 lg:py-10 text-white text-center md:mb-8">
      <h2 className="text-3xl md:text-4xl font-bold py-3 md:mb-6 md:mt-6">
        OUR TRUSTED PARTNERS
      </h2>

      <div className="max-w-5xl mx-auto px-4 space-y-6">
        {/* First Row - 3 Columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {firstRow.map((partner, index) => (
            <div
              key={index}
              className="bg-white p-4 rounded-lg flex justify-center items-center shadow-lg 
              hover:scale-105 duration-300 ease-in-out 
              min-h-[150px]"
            >
              <img
                src={partner.src}
                alt={partner.alt}
                className="max-w-[240px] w-full object-contain"
              />
            </div>
          ))}
        </div>

        {/* Second Row */}
        {secondRow.length === 1 ? (
          // If only one item, center it with flex
          <div className="flex justify-center">
            <div
              className="bg-white p-4 rounded-lg flex justify-center items-center shadow-lg 
              hover:scale-105 duration-300 ease-in-out 
              min-h-[150px] w-full sm:w-1/2 lg:w-1/3"
            >
              <img
                src={secondRow[0].src}
                alt={secondRow[0].alt}
                className="max-w-[240px] w-full object-contain"
              />
            </div>
          </div>
        ) : (
          // Otherwise use grid like usual
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
            {secondRow.map((partner, index) => (
              <div
                key={index}
                className="bg-white p-4 rounded-lg flex justify-center items-center shadow-lg 
                hover:scale-105 duration-300 ease-in-out 
                min-h-[150px]"
              >
                <img
                  src={partner.src}
                  alt={partner.alt}
                  className="max-w-[240px] w-full object-contain"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default OurPartners;
